import { Route } from 'react-router-dom';

import AcceptAccountInvitePage from './accept-account-invite/accept-account-invite.component';
import AcceptUserInvitePage from './accept-user-invite/accept-user-invite.component';
import BackupNotificationUserPage from './backup-notification-user/backup-notification-user.component';

export const StandaloneRoutes = () => {
    return (
        <Route path='standalone'>
            <Route
                path='accept-user-invite/:hash'
                element={<AcceptUserInvitePage />}
            />
            <Route
                path='accept-account-invite/:hash'
                element={<AcceptAccountInvitePage />}
            />
            <Route
                path='backup-notification-user'
                element={<BackupNotificationUserPage />}
            />
        </Route>
    );
};
